<a class="unruly-navigation-item-wrapper" #navItemWrapper
  [ngClass]="{
    'non-clickable': parent.path == null && !parent.actionId,
    'selected': parent.isSelected !== undefined && parent.isSelected,
    'collapsed': isCollapsed,
    'disabled': parent.disabled
  }"
  (mouseenter)="onMouseEnter(); $event.stopPropagation()"
  (mouseleave)="onMouseLeave(); $event.stopPropagation()"
  (click)="itemClicked(parent); $event.stopPropagation()"
  [routerLink]="getRouterLinkPath(parent) || null"
  [queryParams]="getRouterLinkQueryParams(parent) || null">

  <div class="icon" [ngClass]="{'has-projected-icon': hasProjectedIcon}">
    <ng-container *ngIf="hasProjectedIcon; else icon_tpl">
      <ng-content></ng-content>
    </ng-container>
  </div>
  <div class="label" *ngIf="!isCollapsed" @fadeWidthInOut>
    <ng-template *ngTemplateOutlet="label_tpl"></ng-template>
  </div>
  <div class="children" #navItemChildren
    *ngIf="(parent.children?.length || (isCollapsed && !parent.children)) && (isCollapsed ? fixedLocationPosition : parent.showChildren)" 
    [ngClass]="{'expanded': parent.showChildren}" 
    [ngStyle]="fixedLocationPosition">
    <ng-template *ngTemplateOutlet="children_tpl"></ng-template>
  </div>

</a>




<ng-template #icon_tpl>
  <div [id]="parent.id" class="navigation-item-icon" [ngClass]="parent.class">
    <fa-layers *ngIf="parent.iconLayers?.length; else lottieTpl">
      <ng-container *ngFor="let layer of parent.iconLayers">
        <fa-icon [icon]="[layer.type || 'fas', layer.icon]" [transform]="layer.transform || ''" [style]="layer.style || ''" [pulse]="layer.spin || false"></fa-icon>
      </ng-container>
    </fa-layers>
    <ng-template #lottieTpl>
      <ng-container *ngIf="parent.lottieFile && (options['path'] || options['animationData'])">
        <ng-lottie (animationCreated)="animationCreated($event)" [options]="options"></ng-lottie>
      </ng-container>
    </ng-template>
  </div>
</ng-template>



<ng-template #label_tpl>
  <span>{{parent.label}}</span>
  <fa-icon *ngIf="parent.children?.length" icon="caret-down" [rotate]="parent.showChildren ? 180 : 0"></fa-icon>
</ng-template>



<ng-template #children_tpl>
  <div *ngIf="parent.children?.length; else parentTooltipTpl" class="navigation-item-children-wrapper">
    <a *ngIf="isCollapsed" class="navigation-item-child parent-label">
      {{parent.label}}
    </a>
    <ng-container *ngFor="let child of parent.children">
      <a (click)="itemClicked(child); $event.stopPropagation()"
          [routerLink]="getRouterLinkPath(child) || null"
          [queryParams]="getRouterLinkQueryParams(child) || null"
          [id]="child.id" [ngClass]="{'selected': child.isSelected !== undefined && child.isSelected}"
          class="navigation-item-child">
        {{child.label}}
      </a>
    </ng-container>
  </div>
</ng-template>



<ng-template #parentTooltipTpl>
  <ng-container *ngIf="isCollapsed || parent.tooltip">
    <div class="navigation-item-children-wrapper no-children">
      <div class="navigation-item-child parent-label">
        <span *ngIf="isCollapsed">{{parent.label}}</span>
        <span *ngIf="parent.tooltip">{{isCollapsed ? '. ' : ''}}{{parent.tooltip}}</span>
      </div>
    </div>
  </ng-container>
</ng-template>


